import moment from 'moment';
export const maleColors = ['#5086F3', '#F17C86'];

export const genderBreakdownList = [
  { key: 'male', text: 'Male', color: maleColors[0] },
  { key: 'female', text: 'Female', color: maleColors[1] },
];

export const ageBreakdownList = [
  // 新版（5桶）
  {
    orderType: 'age',
    sortMetric: '<25',
    key: '<25',
    text: 'Age < 25',
    title: 'Age < 25',
    color: '#5086F3',
  },
  {
    orderType: 'age',
    sortMetric: '25-34',
    key: '25-34',
    text: 'Age 25 - 34',
    title: 'Age 25 - 34',
    color: '#5EC8F1',
  },
  {
    orderType: 'age',
    sortMetric: '35-44',
    key: '35-44',
    text: 'Age 35 - 44',
    title: 'Age 35 - 44',
    color: '#69D19C',
  },
  {
    orderType: 'age',
    sortMetric: '45-54',
    key: '45-54',
    text: 'Age 45 - 54',
    title: 'Age 45 - 54',
    color: '#58DEC7',
  },
  {
    orderType: 'age',
    sortMetric: '55+',
    key: '55+',
    text: 'Age > 55',
    title: 'Age > 55',
    color: '#F5D242',
  },
  // 旧版（兜底）
  {
    orderType: 'age',
    sortMetric: 'lt25',
    key: 'lt25',
    text: 'Age < 25',
    title: 'Age < 25',
    color: '#5086F3',
  },
  {
    orderType: 'age',
    sortMetric: 'gte25',
    key: 'gte25',
    text: 'Age >= 25',
    title: 'Age >= 25',
    color: '#F19E55',
  },
  {
    orderType: 'age',
    sortMetric: 'gte25_lte34',
    key: 'gte25_lte34',
    text: 'Age 25 - 34',
    title: 'Age 25 - 34',
    color: '#5EC8F1',
  },
  {
    orderType: 'age',
    sortMetric: 'gte25_lte44',
    key: 'gte25_lte44',
    text: 'Age 25 - 44',
    title: 'Age 25 - 44',
    color: '#58DEC7',
  },
  {
    orderType: 'age',
    sortMetric: 'gte35_lte44',
    key: 'gte35_lte44',
    text: 'Age 35 - 44',
    title: 'Age 35 - 44',
    color: '#69D19C',
  },
  {
    orderType: 'age',
    sortMetric: 'gt44',
    key: 'gt44',
    text: 'Age > 44',
    title: 'Age > 44',
    color: '#F5D242',
  },
];
export const tableOptions = [
  {
    text: 'MAU', //表格头部
    textRatio: 'MAU(%)', //表格环比头部
    metricName: 'MAU', //卡片指标名及SortBy展示
    metricNameRatio: 'MAU(%)', //卡片指标名的环比SortBy展示
    value: 'mau', //参数值
    width: 200, //表头宽度； 详情页和榜单共用，请注意榜单有ICON情况
  },
];

export const getDemographicChartSortName = (
  metric: string,
  ratioType: number = 0,
) => {
  const breakdownList = [...genderBreakdownList, ...ageBreakdownList];
  const item = breakdownList.find((item: any) => {
    return item.key === metric;
  });
  if (item?.text) {
    return item.text;
  }
  const item2 = tableOptions.find((item: any) => {
    return item.value === metric;
  });
  return ratioType === 1 ? item2?.textRatio : item2?.text;
};

export const getAgeSortList = (keys: string[], oldList: any[]) => {
  if (!Array.isArray(keys) || !Array.isArray(oldList)) {
    return [];
  }
  return keys
    .map((key) => {
      return oldList.find((t) => {
        return t?.key === key;
      });
    })
    .filter(Boolean);
};

export const handleTableBarList = (
  currentMetric: string,
  breakdownList: any[] = [],
  metricList: any[] = [],
): any[] => {
  const list: any[] = [];
  breakdownList?.forEach((item: any) => {
    const metricItem = metricList.find((t: any) => {
      return t?.name === item?.key;
    });
    if (metricItem) {
      const perValu = (metricItem.value * 100).toFixed(1) + '%';
      const obj = {
        name: item.text,
        // width: metricItem.value * 100 + '%',
        color: item.color,
        value: perValu,
        //下面的数据是转换为重构组件TableChart使用
        lengendTitle: perValu,
        title: item.text,
        num: perValu,
      };
      const gte25 = [
        'gte25',
        'gte25_lte34',
        'gte25_lte44',
        'gte35_lte44',
        'gt44',
      ];
      const gte25_lte44 = ['gte25_lte44', 'gte25_lte34', 'gte35_lte44'];
      if (
        (currentMetric === 'gte25' && gte25.includes(metricItem?.name)) ||
        (currentMetric === 'gte25_lte44' &&
          gte25_lte44.includes(metricItem?.name)) ||
        currentMetric === metricItem?.name
      ) {
        list.unshift(obj);
      } else {
        list.push(obj);
      }
    }
  });
  return list;
};

export const companyFilterParams = {
  entity_type: 'mobile',
  source: 'appannie demographics monthly',
  metric: 'breakdown',
  region_type: 'market',
  regions: ['us'],
  granularity: 'monthly',
  start_date: '1970-01-01',
  end_date: moment().subtract(1, 'd').format('YYYY-MM-DD'),
  data_sources: ['appannie demographics monthly'],
  page_size: 500,
  search_name: '',
  page: 1,
}